import { Route, Routes } from 'react-router-dom';
import React, { Suspense } from "react";
import ClimaLaboral from "../../../views/CrecimientoHumano/ClimaLaboral/ClimaLaboral";

const CrecimientoHumano = () => {
    return (
        <Routes>
            <Route exact path="/crecimientohumano/climalaboral"
                   element={
                       <Suspense fallback={<>skeleton</>}>
                           <ClimaLaboral/>
                       </Suspense>
                   }>
            </Route>
        </Routes>
    )

}

export default CrecimientoHumano
